/**
 * Free Gift for Email Subscribers - Atratus Colombia
 * Adds a free Cuellito Harpía to cart when user subscribes via Shopify Forms popup
 * ONLY if they have other products in cart (not just the gift alone)
 *
 * Gift Variant ID: 48274742345893
 */

(function() {
  'use strict';

  // Configuration
  const CONFIG = {
    enabled: false,  // DISABLED - variant "Regalo suscripción" was deleted from Shopify
    detectNewSubscriptions: false,
    giftVariantId: 48274742345893,  // This variant no longer exists
    storageKey: 'atratus_gift_received',
    eligibleKey: 'atratus_gift_eligible',
    cartAddUrl: '/cart/add.js',
    cartUrl: '/cart',
    giftProductTitle: 'Cuellito Harpía',
    debug: true  // ENABLED for debugging - set to false in production
  };

  // Track if we've already tried to add gift this session
  let giftAttempted = false;

  // Utility functions
  function log(...args) {
    if (CONFIG.debug) {
      console.log('[FreeGift]', ...args);
    }
  }

  function hasReceivedGift() {
    try {
      return localStorage.getItem(CONFIG.storageKey) === 'true';
    } catch (e) {
      log('localStorage not available:', e);
      return false;
    }
  }

  function markGiftReceived() {
    try {
      localStorage.setItem(CONFIG.storageKey, 'true');
      localStorage.removeItem(CONFIG.eligibleKey); // Clean up eligible flag
      log('Gift marked as received');
    } catch (e) {
      log('Could not save to localStorage:', e);
    }
  }

  function isEligibleForGift() {
    try {
      return localStorage.getItem(CONFIG.eligibleKey) === 'true';
    } catch (e) {
      log('localStorage not available:', e);
      return false;
    }
  }

  function markEligible() {
    try {
      localStorage.setItem(CONFIG.eligibleKey, 'true');
      log('User marked as eligible for gift');
    } catch (e) {
      log('Could not save to localStorage:', e);
    }
  }

  async function getCartData() {
    try {
      const response = await fetch('/cart.js');
      return await response.json();
    } catch (e) {
      log('Error fetching cart:', e);
      return null;
    }
  }

  async function isGiftAlreadyInCart() {
    const cart = await getCartData();
    if (!cart) return false;
    return cart.items.some(item => item.variant_id === CONFIG.giftVariantId);
  }

  async function hasOtherProductsInCart() {
    const cart = await getCartData();
    if (!cart || !cart.items) return false;

    // Check if there's at least one item that is NOT the gift
    const otherProducts = cart.items.filter(item => item.variant_id !== CONFIG.giftVariantId);
    log('Other products in cart:', otherProducts.length);
    return otherProducts.length > 0;
  }

  // Called when user subscribes - marks as eligible but doesn't add gift yet
  async function handleSubscription() {
    log('Subscription detected!');

    // Check if gift already received
    if (hasReceivedGift()) {
      log('Gift already received (localStorage)');
      return;
    }

    // Check if already eligible
    if (isEligibleForGift()) {
      log('User already eligible');
      // Check if they now have products in cart
      await tryToAddGift();
      return;
    }

    // Mark as eligible
    markEligible();

    // Check if cart has other products
    const hasProducts = await hasOtherProductsInCart();

    if (hasProducts) {
      // They have products - add the gift now!
      await addGiftToCart();
    } else {
      // No products yet - show "add a product" message
      showNotification('eligible');
    }
  }

  // Try to add gift if eligible and has other products
  async function tryToAddGift() {
    if (hasReceivedGift()) {
      log('Gift already received');
      return false;
    }

    if (!isEligibleForGift()) {
      log('User not eligible for gift');
      return false;
    }

    const hasProducts = await hasOtherProductsInCart();
    if (!hasProducts) {
      log('Cart has no other products yet');
      return false;
    }

    const inCart = await isGiftAlreadyInCart();
    if (inCart) {
      log('Gift already in cart');
      markGiftReceived();
      return false;
    }

    return await addGiftToCart();
  }

  async function addGiftToCart() {
    // Prevent multiple attempts
    if (giftAttempted) {
      log('Gift already attempted this session');
      return false;
    }
    giftAttempted = true;

    log('Attempting to add gift to cart...');

    // Check if gift already received
    if (hasReceivedGift()) {
      log('Gift already received (localStorage)');
      return false;
    }

    // Check if gift already in cart
    const inCart = await isGiftAlreadyInCart();
    if (inCart) {
      log('Gift already in cart');
      markGiftReceived();
      return false;
    }

    // Add to cart
    try {
      const response = await fetch(CONFIG.cartAddUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({
          items: [{
            id: CONFIG.giftVariantId,
            quantity: 1,
            properties: {
              '_gift': 'true',
              '_gift_reason': 'Suscripción email'
            }
          }]
        })
      });

      if (!response.ok) {
        const errorData = await response.json();
        log('Error adding to cart:', errorData);

        // If variant not available, show alternative message
        if (errorData.description && errorData.description.includes('not available')) {
          showNotification('error');
        }
        return false;
      }

      const data = await response.json();
      log('Gift added successfully:', data);

      markGiftReceived();
      showNotification('success');

      // Trigger cart update event for cart drawer
      document.dispatchEvent(new CustomEvent('cart:refresh'));

      // Also try to update cart counter
      try {
        const cartResponse = await fetch('/cart.js');
        const cart = await cartResponse.json();
        document.querySelectorAll('.cart-count-bubble, [data-cart-count]').forEach(el => {
          el.textContent = cart.item_count;
        });
      } catch (e) {
        log('Could not update cart counter:', e);
      }

      return true;
    } catch (e) {
      log('Error adding gift to cart:', e);
      return false;
    }
  }

  function showNotification(type) {
    const notification = document.getElementById('free-gift-notification');
    if (!notification) {
      log('Notification element not found');
      return;
    }

    const successContent = notification.querySelector('.free-gift-success');
    const errorContent = notification.querySelector('.free-gift-error');
    const eligibleContent = notification.querySelector('.free-gift-eligible');

    // Hide all first
    if (successContent) successContent.style.display = 'none';
    if (errorContent) errorContent.style.display = 'none';
    if (eligibleContent) eligibleContent.style.display = 'none';

    // Show the right one
    if (type === 'success') {
      if (successContent) successContent.style.display = 'flex';
    } else if (type === 'eligible') {
      if (eligibleContent) eligibleContent.style.display = 'flex';
    } else {
      if (errorContent) errorContent.style.display = 'flex';
    }

    notification.classList.add('active');

    // Auto-hide after 10 seconds
    setTimeout(() => {
      notification.classList.remove('active');
    }, 10000);
  }

  function closeNotification() {
    const notification = document.getElementById('free-gift-notification');
    if (notification) {
      notification.classList.remove('active');
    }
  }

  // Expose close function globally
  window.closeFreeGiftNotification = closeNotification;

  // ============================================
  // CART CHANGE WATCHER
  // ============================================

  function setupCartWatcher() {
    // Watch for cart changes via fetch interception
    const originalFetch = window._originalFetch || window.fetch;

    // Store original fetch if not already stored
    if (!window._originalFetch) {
      window._originalFetch = window.fetch;
    }

    window.fetch = async function(...args) {
      const response = await originalFetch.apply(this, args);
      const url = args[0]?.toString() || '';

      // Check if this is a cart add operation (but not our gift add)
      if (url.includes('/cart/add') && isEligibleForGift() && !hasReceivedGift()) {
        log('Cart add detected, checking if we should add gift...');

        // Wait a moment for cart to update, then check
        setTimeout(async () => {
          giftAttempted = false; // Reset so we can try again
          await tryToAddGift();
        }, 500);
      }

      return response;
    };

    // Also listen for cart:refresh events that some themes emit
    document.addEventListener('cart:refresh', async function() {
      if (isEligibleForGift() && !hasReceivedGift()) {
        log('Cart refresh event detected');
        setTimeout(async () => {
          giftAttempted = false;
          await tryToAddGift();
        }, 500);
      }
    });

    // Listen for ajaxCart events (common in themes)
    document.addEventListener('ajaxCart.itemAdded', async function() {
      if (isEligibleForGift() && !hasReceivedGift()) {
        log('ajaxCart.itemAdded event detected');
        setTimeout(async () => {
          giftAttempted = false;
          await tryToAddGift();
        }, 500);
      }
    });

    log('Cart watcher setup complete');
  }

  // ============================================
  // DETECTION METHODS FOR SHOPIFY FORMS
  // ============================================

  // Method 1: MutationObserver - Watch for ANY changes that indicate success
  function setupMutationObserver() {
    const observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        // Check added nodes
        mutation.addedNodes.forEach(function(node) {
          if (node.nodeType === Node.ELEMENT_NODE) {
            checkNodeForSuccess(node);
          }
        });

        // Check attribute changes (Shopify Forms often changes attributes on success)
        if (mutation.type === 'attributes') {
          checkNodeForSuccess(mutation.target);
        }

        // Check if form was hidden/removed (might indicate success)
        if (mutation.type === 'childList' && mutation.removedNodes.length > 0) {
          mutation.removedNodes.forEach(function(node) {
            if (node.nodeType === Node.ELEMENT_NODE) {
              const wasForm = node.querySelector?.('form') || node.tagName === 'FORM';
              const hadEmail = node.querySelector?.('input[type="email"]');
              if (wasForm && hadEmail) {
                log('Form with email input was removed - might be success');
                // Check if there's now a success message visible
                setTimeout(checkForSuccessState, 500);
              }
            }
          });
        }
      });
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['class', 'data-state', 'data-form-state', 'aria-hidden', 'style']
    });

    log('MutationObserver setup complete (watching for changes)');
  }

  function checkNodeForSuccess(node) {
    if (!node || !node.classList) return;

    const successIndicators = [
      // Class-based indicators
      'shopify-form--success',
      'form--success',
      'newsletter--success',
      'popup--success',
      'success-message',
      'thank-you',
      'subscription-success',
      'email-success',
      // Shopify Forms specific
      'shopify-challenge-form-success',
      'form-success'
    ];

    const nodeClasses = Array.from(node.classList || []);
    const nodeText = (node.textContent || '').toLowerCase();

    // Check classes
    const hasSuccessClass = successIndicators.some(indicator =>
      nodeClasses.some(cls => cls.toLowerCase().includes(indicator.toLowerCase()))
    );

    // Check text content for success messages (Spanish and English)
    const successTexts = [
      'gracias',
      'suscrito',
      'suscrita',
      'registrado',
      'registrada',
      'thank you',
      'subscribed',
      'success',
      'bienvenido',
      'bienvenida'
    ];
    const hasSuccessText = successTexts.some(text => nodeText.includes(text));

    // Check data attributes
    const hasSuccessAttribute =
      node.getAttribute?.('data-state') === 'success' ||
      node.getAttribute?.('data-form-state') === 'success';

    if (hasSuccessClass || hasSuccessAttribute || (hasSuccessText && nodeText.length < 200)) {
      log('Success state detected in node:', {
        hasSuccessClass,
        hasSuccessAttribute,
        hasSuccessText,
        nodeText: nodeText.substring(0, 100)
      });
      handleSubscription();
    }

    // Also check children
    if (node.querySelector) {
      successIndicators.forEach(indicator => {
        if (node.querySelector('.' + indicator)) {
          log('Success class found in child:', indicator);
          handleSubscription();
        }
      });
    }
  }

  function checkForSuccessState() {
    log('Checking for success state on page...');

    // Look for any visible success messages
    const selectors = [
      '.shopify-form--success:not([hidden])',
      '.form--success:not([hidden])',
      '[data-state="success"]',
      '[data-form-state="success"]',
      '.thank-you-message',
      '.success-message'
    ];

    selectors.forEach(selector => {
      const element = document.querySelector(selector);
      if (element && element.offsetParent !== null) {
        log('Found visible success element:', selector);
        handleSubscription();
      }
    });
  }

  // Method 2: Listen for ALL potentially relevant events
  function setupEventListeners() {
    const events = [
      // Custom Shopify events
      'shopify:form:success',
      'shopify-form:success',
      'form:success',
      'newsletter:subscribed',
      'customer:subscribed',
      // Generic events
      'formSuccess',
      'subscriptionSuccess',
      'popupClose',
      // Shopify Forms App specific
      'ShopifyForm:success',
      'ShopifyForm:submit:success'
    ];

    events.forEach(function(eventName) {
      document.addEventListener(eventName, function(e) {
        log('Custom event detected:', eventName, e);
        handleSubscription();
      });
      window.addEventListener(eventName, function(e) {
        log('Window custom event detected:', eventName, e);
        handleSubscription();
      });
    });

    // Also listen on specific form elements when they appear
    document.addEventListener('DOMContentLoaded', function() {
      document.querySelectorAll('form').forEach(attachFormListeners);
    });

    log('Event listeners setup complete');
  }

  function attachFormListeners(form) {
    const hasEmail = form.querySelector('input[type="email"]');
    if (!hasEmail) return;

    log('Attaching listeners to email form:', form);

    // Listen for submit
    form.addEventListener('submit', function(e) {
      log('Form submitted:', form);

      // Check for success after a delay
      setTimeout(checkForSuccessState, 1500);
      setTimeout(checkForSuccessState, 3000);
      setTimeout(checkForSuccessState, 5000);
    });
  }

  // Method 3: Intercept fetch/XHR for Shopify Forms API calls
  function setupNetworkInterceptor() {
    // Store original fetch
    const originalFetch = window._originalFetch || window.fetch;
    if (!window._originalFetch) {
      window._originalFetch = window.fetch;
    }

    window.fetch = async function(...args) {
      const response = await originalFetch.apply(this, args);

      const url = args[0]?.toString() || '';

      // Check if this is a Shopify Forms submission
      if (url.includes('/contact') ||
          url.includes('customer') ||
          url.includes('subscribe') ||
          url.includes('newsletter') ||
          url.includes('marketing')) {

        log('Detected potential subscription fetch:', url);

        // Clone response to read it
        const clone = response.clone();
        try {
          const data = await clone.json();
          log('Response data:', data);

          // Check for success indicators
          if (data.success || data.status === 'success' || response.ok) {
            log('Successful subscription detected via fetch');
            setTimeout(() => handleSubscription(), 500);
          }
        } catch (e) {
          // Not JSON, might still be success
          if (response.ok) {
            log('Fetch succeeded (non-JSON response)');
            setTimeout(() => handleSubscription(), 500);
          }
        }
      }

      // Also check for cart add (for cart watcher)
      if (url.includes('/cart/add') && isEligibleForGift() && !hasReceivedGift()) {
        log('Cart add detected via fetch, will check for gift eligibility...');
        setTimeout(async () => {
          giftAttempted = false;
          await tryToAddGift();
        }, 500);
      }

      return response;
    };

    // Intercept XMLHttpRequest
    const originalXHROpen = XMLHttpRequest.prototype.open;
    const originalXHRSend = XMLHttpRequest.prototype.send;

    XMLHttpRequest.prototype.open = function(method, url, ...rest) {
      this._url = url;
      return originalXHROpen.apply(this, [method, url, ...rest]);
    };

    XMLHttpRequest.prototype.send = function(...args) {
      const url = this._url || '';

      if (url.includes('/contact') ||
          url.includes('customer') ||
          url.includes('subscribe') ||
          url.includes('newsletter')) {

        log('Detected potential subscription XHR:', url);

        this.addEventListener('load', function() {
          if (this.status >= 200 && this.status < 300) {
            log('Successful subscription detected via XHR');
            setTimeout(() => handleSubscription(), 500);
          }
        });
      }

      // Also check for cart add
      if (url.includes('/cart/add') && isEligibleForGift() && !hasReceivedGift()) {
        this.addEventListener('load', function() {
          if (this.status >= 200 && this.status < 300) {
            log('Cart add detected via XHR');
            setTimeout(async () => {
              giftAttempted = false;
              await tryToAddGift();
            }, 500);
          }
        });
      }

      return originalXHRSend.apply(this, args);
    };

    log('Network interceptor setup complete');
  }

  // Method 4: Check URL parameters
  function checkUrlForSubscription() {
    const urlParams = new URLSearchParams(window.location.search);
    const subscribed = urlParams.get('customer_posted') === 'true' ||
                       urlParams.get('form_type') === 'customer' ||
                       urlParams.get('subscribed') === 'true' ||
                       urlParams.get('newsletter_signup') === 'true';

    if (subscribed) {
      log('Subscription detected via URL parameter');
      handleSubscription();
    }
  }

  // Method 5: Periodic check for popup state changes
  function setupPopupWatcher() {
    let lastPopupState = null;

    setInterval(function() {
      // Look for Shopify Forms popup elements
      const popups = document.querySelectorAll(
        '[class*="shopify-form"], [class*="popup"], [class*="modal"], [id*="popup"], [id*="modal"]'
      );

      popups.forEach(popup => {
        const hasEmail = popup.querySelector('input[type="email"]');
        if (!hasEmail) return;

        // Check if popup shows success state
        const classes = popup.className || '';
        const dataState = popup.getAttribute('data-state') || '';
        const text = popup.textContent || '';

        const currentState = classes + dataState + text.substring(0, 100);

        if (lastPopupState !== null && currentState !== lastPopupState) {
          // State changed
          if (classes.includes('success') ||
              dataState === 'success' ||
              text.toLowerCase().includes('gracias') ||
              text.toLowerCase().includes('suscrito')) {
            log('Popup state changed to success');
            handleSubscription();
          }
        }

        lastPopupState = currentState;
      });
    }, 1000);

    log('Popup watcher setup complete');
  }

  // ============================================
  // REMOVE GIFT IF IT'S THE ONLY ITEM IN CART
  // ============================================

  async function removeGiftIfAlone() {
    const cart = await getCartData();
    if (!cart || !cart.items || cart.items.length === 0) return;

    // Find the gift in cart
    const giftItem = cart.items.find(item => item.variant_id === CONFIG.giftVariantId);
    if (!giftItem) return; // Gift not in cart, nothing to do

    // Check if gift is the ONLY item
    const otherItems = cart.items.filter(item => item.variant_id !== CONFIG.giftVariantId);

    if (otherItems.length === 0) {
      // Gift is alone! Remove it
      log('Gift is the only item in cart - removing it');

      try {
        const response = await fetch('/cart/change.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify({
            id: giftItem.key,
            quantity: 0
          })
        });

        if (response.ok) {
          log('Gift removed from cart (was alone)');

          // IMPORTANT: Reset the "received" flag so gift can be re-added when they add products
          // But keep them as "eligible"
          localStorage.removeItem(CONFIG.storageKey);
          giftAttempted = false;
          log('Reset gift state - user still eligible, can receive gift when adding products');

          // Refresh the page if we're on cart page
          if (window.location.pathname.includes('/cart')) {
            window.location.reload();
          }

          // Trigger cart update
          document.dispatchEvent(new CustomEvent('cart:refresh'));
        }
      } catch (e) {
        log('Error removing gift:', e);
      }
    }
  }

  // Check cart periodically and on key events
  function setupCartValidator() {
    // Check immediately
    removeGiftIfAlone();

    // Check when page loads
    window.addEventListener('load', removeGiftIfAlone);

    // Check periodically (every 2 seconds)
    setInterval(removeGiftIfAlone, 2000);

    // Check on cart page specifically
    if (window.location.pathname.includes('/cart') || window.location.pathname.includes('/checkout')) {
      removeGiftIfAlone();
    }

    // Intercept checkout button clicks
    document.addEventListener('click', function(e) {
      const target = e.target;
      const isCheckoutButton =
        target.name === 'checkout' ||
        target.closest('[name="checkout"]') ||
        target.closest('form[action="/cart"]') ||
        target.textContent?.toLowerCase().includes('pagar') ||
        target.textContent?.toLowerCase().includes('checkout') ||
        target.closest('[href*="/checkout"]');

      if (isCheckoutButton) {
        // Quick check before allowing checkout
        removeGiftIfAlone();
      }
    }, true);

    log('Cart validator setup complete');
  }

  // ============================================
  // HIDE GIFT VARIANT FROM PRODUCT PAGE
  // ============================================

  function hideGiftVariant() {
    // Hide variant buttons/options containing "Regalo" or "Gift"
    const hideSelectors = [
      // Variant buttons (common in Dawn and similar themes)
      'input[type="radio"][value*="Regalo"]',
      'input[type="radio"][value*="regalo"]',
      'input[type="radio"][value*="Gift"]',
      'label[for*="Regalo"]',
      'label[for*="regalo"]',
      // Variant pills/buttons
      'button:contains("Regalo")',
      '.variant-input-wrapper:has(input[value*="Regalo"])',
      '.variant-input:has(input[value*="Regalo"])',
      // Select option
      'option[value*="Regalo"]',
      'option:contains("Regalo")'
    ];

    // Method 1: Hide by text content
    document.querySelectorAll('label, button, .swatch, [class*="variant"]').forEach(el => {
      const text = el.textContent || '';
      if (text.toLowerCase().includes('regalo') || text.toLowerCase().includes('suscripción')) {
        // Find the parent wrapper and hide it
        const wrapper = el.closest('.variant-input-wrapper, .variant__input-wrapper, .product-form__input, [class*="swatch"], fieldset > div');
        if (wrapper) {
          wrapper.style.display = 'none';
          log('Hidden gift variant wrapper:', wrapper);
        } else {
          el.style.display = 'none';
          log('Hidden gift variant element:', el);
        }
      }
    });

    // Method 2: Hide select options with "Regalo"
    document.querySelectorAll('select option').forEach(option => {
      if (option.textContent.toLowerCase().includes('regalo')) {
        option.style.display = 'none';
        option.disabled = true;
        log('Hidden/disabled gift variant option:', option);
      }
    });

    // Method 3: Hide by variant ID in data attributes
    document.querySelectorAll(`[data-variant-id="${CONFIG.giftVariantId}"], [value="${CONFIG.giftVariantId}"]`).forEach(el => {
      const wrapper = el.closest('.variant-input-wrapper, .variant__input-wrapper, .product-form__input, [class*="swatch"]');
      if (wrapper) {
        wrapper.style.display = 'none';
      } else {
        el.style.display = 'none';
      }
      log('Hidden gift variant by ID:', el);
    });

    log('Gift variant hiding complete');
  }

  // Watch for dynamically loaded product forms
  function setupVariantHider() {
    // Initial hide
    hideGiftVariant();

    // Watch for new elements (for AJAX-loaded content)
    const observer = new MutationObserver(function(mutations) {
      let shouldCheck = false;
      mutations.forEach(function(mutation) {
        if (mutation.addedNodes.length > 0) {
          mutation.addedNodes.forEach(function(node) {
            if (node.nodeType === Node.ELEMENT_NODE) {
              // Check if this might be a product form or variant selector
              if (node.querySelector && (
                node.querySelector('[class*="variant"]') ||
                node.querySelector('input[type="radio"]') ||
                node.classList?.toString().includes('variant') ||
                node.classList?.toString().includes('product')
              )) {
                shouldCheck = true;
              }
            }
          });
        }
      });
      if (shouldCheck) {
        setTimeout(hideGiftVariant, 100);
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });

    log('Variant hider observer setup complete');
  }

  // ============================================
  // INITIALIZATION
  // ============================================

  function init() {
    // Check if system is enabled
    if (!CONFIG.enabled) {
      console.log('[FreeGift] System is DISABLED. Set CONFIG.enabled = true to reactivate.');

      // Clean up: close any open notifications
      const notification = document.getElementById('free-gift-notification');
      if (notification) {
        notification.classList.remove('active');
        notification.style.display = 'none';
      }

      // Clean up: clear localStorage flags
      try {
        localStorage.removeItem(CONFIG.storageKey);
        localStorage.removeItem(CONFIG.eligibleKey);
      } catch (e) {}

      return;
    }

    log('========================================');
    log('Initializing Free Gift system...');
    log('Variant ID:', CONFIG.giftVariantId);
    log('Detect new subscriptions:', CONFIG.detectNewSubscriptions);
    log('========================================');

    // Always hide the gift variant from product pages
    setupVariantHider();

    // Always validate cart (remove gift if alone)
    setupCartValidator();

    // Skip if gift already received
    if (hasReceivedGift()) {
      log('Gift already received, skipping initialization');
      return;
    }

    // Check if user is already eligible (from previous session)
    if (isEligibleForGift()) {
      log('User is eligible from previous session, checking cart...');
      tryToAddGift();

      // Setup cart watcher so gift is added when they add products
      setupCartWatcher();
      log('Cart watcher active - gift will be added when user adds products');
      return;
    }

    // If we're not detecting new subscriptions, stop here
    if (!CONFIG.detectNewSubscriptions) {
      log('Not detecting new subscriptions. Only existing eligible users can get gift.');
      return;
    }

    // Setup all detection methods (only if detectNewSubscriptions is true)
    setupMutationObserver();
    setupEventListeners();
    setupNetworkInterceptor();
    setupCartWatcher();
    checkUrlForSubscription();
    setupPopupWatcher();

    // Attach to any existing forms
    document.querySelectorAll('form').forEach(attachFormListeners);

    log('Free Gift system initialized - watching for subscriptions');
    log('To test manually, run: window.testFreeGift()');
  }

  // Expose test function globally
  window.testFreeGift = function() {
    log('Manual test triggered');
    giftAttempted = false; // Reset for testing
    handleSubscription();
  };

  // Reset function for testing
  window.resetFreeGift = function() {
    localStorage.removeItem(CONFIG.storageKey);
    localStorage.removeItem(CONFIG.eligibleKey);
    giftAttempted = false;
    log('Free gift state reset');
  };

  // Start when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
